import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative isolate overflow-hidden text-white px-3 pb-24 sm:pt-16 sm:pb-32 lg:overflow-visible lg:px-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "flex justify-center mb-5" }, [
      _createElementVNode("a", { href: "/" }, [
        _createElementVNode("img", {
          src: "/images/logo.webp",
          alt: "Links Digest",
          class1: "h-10 w-10"
        })
      ])
    ], -1),
    _createElementVNode("div", { class: "mx-auto grid max-w-2xl gap-y-16 lg:mx-0 lg:max-w-none 1 lg:items-start lg:gap-y-10" }, [
      _createElementVNode("div", { class: "lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8" }, [
        _createElementVNode("div", { class: "lg:pr-4" }, [
          _createElementVNode("div", null, [
            _createElementVNode("p", { class: "text-base/7 font-semibold text-cyan-400" }, "Links Digest"),
            _createElementVNode("h1", { class: "mt-2 text-4xl font-semibold tracking-tight text-pretty sm:text-5xl" }, "Privacy Policy"),
            _createElementVNode("p", { class: "mt-2" }, [
              _createElementVNode("strong", null, "Last updated:"),
              _createTextVNode(" January 26th, 2026")
            ]),
            _createElementVNode("p", { class: "mt-6 text-xl/8" }, [
              _createTextVNode(" This Privacy Policy explains how "),
              _createElementVNode("strong", null, "Lazuli Labs, Lda"),
              _createTextVNode(" (\"we\", \"our\", \"us\") collects, uses, and protects personal data when you use "),
              _createElementVNode("strong", null, "linksdigest.com"),
              _createTextVNode(" (\"Website\"). ")
            ]),
            _createElementVNode("p", null, [
              _createTextVNode(" We are committed to protecting your privacy and processing your personal data in accordance with applicable data protection laws, including the "),
              _createElementVNode("strong", null, "General Data Protection Regulation (GDPR)"),
              _createTextVNode(". ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", { class: "lg:col-span-2 lg:col-start-1 lg:mx-auto lg:w-full lg:max-w-7xl lg:px-8" }, [
        _createElementVNode("div", { class: "lg:pr-4" }, [
          _createElementVNode("div", { class: "text-base/7" }, [
            _createElementVNode("ul", {
              role: "list",
              class: "mt-8 space-y-8"
            }, [
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "1. Data Controller")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " The data controller responsible for the processing of personal data is: "),
              _createElementVNode("p", { class: "ms-4" }, [
                _createElementVNode("strong", null, "Lazuli Labs, Lda"),
                _createElementVNode("br"),
                _createTextVNode(" Email: "),
                _createElementVNode("a", {
                  href: "mailto:linksdigest@lazulilabs.com",
                  class: "text-white hover:text-cyan-400"
                }, "linksdigest@lazulilabs.com")
              ]),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "2. Personal Data We Collect")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " We may collect and process the following types of personal data: "),
              _createElementVNode("ul", { class: "ms-8" }, [
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Email address and basic account information when you create a user account")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Information you provide when submitting links or contacting us")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Technical data such as IP address, browser type, and device information")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Usage data related to how you interact with the Website")
                ])
              ]),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("span", null, [
                  _createElementVNode("h2", null, "3. How We Use Your Data")
                ])
              ]),
              _createElementVNode("p", { class: "ms-4" }, " We process personal data for the following purposes: "),
              _createElementVNode("ul", { class: "ms-8" }, [
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" To operate and maintain the Website ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" To manage user accounts and submissions ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" To review and approve submitted links ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" To communicate with users ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" To improve our services and user experience ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" To display advertising and analyze performance ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" To comply with legal obligations ")
                ])
              ]),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "4. Legal Basis for Processing")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " We process personal data based on one or more of the following legal grounds: "),
              _createElementVNode("ul", { class: "ms-8" }, [
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Your consent ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" The performance of a contract ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Compliance with legal obligations ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Our legitimate interests, provided they do not override your rights ")
                ])
              ]),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "5. Cookies and Tracking Technologies")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " We use cookies and similar technologies to ensure the proper functioning of the Website, analyze usage, and support advertising. "),
              _createElementVNode("p", { class: "ms-4" }, " You may control or disable cookies through your browser settings. Additional information may be provided in a separate Cookie Policy. "),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "6. Advertising")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " The Website may display third-party advertising. Advertisers may use cookies or similar technologies to collect information about your interactions with ads. "),
              _createElementVNode("p", { class: "ms-4" }, " We are not responsible for the privacy practices of third-party advertisers. "),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "7. Data Sharing")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " We do not sell your personal data. We may share data with: "),
              _createElementVNode("ul", { class: "ms-8" }, [
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Service providers that support the operation of the Website ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Legal or regulatory authorities when required by law ")
                ])
              ]),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "8. Data Retention")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " We retain personal data only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. "),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "9. Your Rights")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " Under GDPR, you have the right to: "),
              _createElementVNode("ul", { class: "ms-8" }, [
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Access your personal data ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Request correction of inaccurate data ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Request deletion of your data ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Restrict or object to processing ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Request data portability ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Withdraw consent at any time ")
                ])
              ]),
              _createElementVNode("p", { class: "ms-4" }, [
                _createTextVNode(" To exercise your rights, please contact us at "),
                _createElementVNode("a", {
                  href: "mailto:linksdigest@lazulilabs.com",
                  class: "text-white hover:text-cyan-400"
                }, "linksdigest@lazulilabs.com"),
                _createTextVNode(". ")
              ]),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "10. Data Security")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " We implement appropriate technical and organizational measures to protect personal data against unauthorized access, loss, or misuse. "),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "11. International Data Transfers")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " If personal data is transferred outside the European Union, we ensure that appropriate safeguards are in place in accordance with GDPR requirements. "),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "12. Changes to This Privacy Policy")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " We reserve the right to update this Privacy Policy at any time. Changes will be effective upon publication on this page. "),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "13. Contact")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " If you have questions or concerns about this Privacy Policy or how we handle personal data, please contact: "),
              _createElementVNode("p", { class: "ms-4" }, [
                _createElementVNode("strong", null, "Lazuli Labs, Lda"),
                _createElementVNode("br"),
                _createElementVNode("a", {
                  href: "mailto:linksdigest@lazulilabs.com",
                  class: "text-white hover:text-cyan-400"
                }, "linksdigest@lazulilabs.com")
              ]),
              _createElementVNode("a", {
                href: "/",
                class: "text-white/40 hover:text-white mt-5"
              }, "Back to Home")
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}